// extracted by mini-css-extract-plugin
export default {"subheader":"SubHeader_subheader__v52yZ"};